import { Component, State, h } from "@stencil/core";


@Component({
  tag: "app-intro-video",
  styleUrl: "app-intro-video.css"
})
export class AppIntroVideo {
  @State() divRef;
  @State() showFrame = false;
  readonly videoId = 'nVvb05IalLI';

  /* <iframe width="1903" height="778" src="https://www.youtube.com/embed/{videoId}" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe> */

  renderFrame() {
    if (!this.showFrame) {
      // console.log('frame = false');
      return <ion-img src="" onIonImgWillLoad={() => this.showFrame = true} alt="Vídeo de Introdução"></ion-img>
    }
    // console.log('loadFrame');
    return <iframe class="video" width="100%" height="100%" frameBorder="0" allowFullScreen={true}
      src={`https://www.youtube.com/embed/${this.videoId}`} ></iframe>;
  }

  render() {
    return (
      <div id="intro-video" class="block-container video-container">
        <h2 class="center-title">Veja o vídeo de introdução</h2>

        <ion-grid>
          <ion-row class="ion-justify-content-center">
            <div class="video-block">
              {/* <lazy-iframe class="video" title='Introdução ao Pager Online'
                  src="https://www.youtube.com/embed/{videoId}" ></lazy-iframe> */}
              {/* <iframe frameBorder="0" title='Introdução ao Pager Online' allowFullScreen={true} src={'this.https://www.youtube.com/embed/{videoId}'} ></iframe> */}
              {this.renderFrame()}
              </div>
          </ion-row>
        </ion-grid>
      </div>
    );
  }
}